module.exports = __webpack_public_path__ + "img/9788971995204.0f65de77.jpg";